export default __webpack_public_path__ + "static/media/logo.46db6447.png";